module.exports = __webpack_public_path__ + "static/media/react.12a0459f.svg";